import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Customers, Pets } from '../types';
import { PetProfileForm } from '../components/PetProfileForm';
import { PetInsuranceForm } from './PetInsuranceForm';
import { VerticalTabs } from './VerticalTab';
import { PetDetailCard } from './MyPetDetailCard';
import { getPet, useGetPet } from '../api/getPet';
import { PetVaccinationForm } from './PetVaccinationForm';

import { ReactComponent as PawIconGrey } from '@/assets/img/menu-paw-icon.svg';
import { ReactComponent as PawIconSelected } from '@/assets/img/menu-paw-icon-selected.svg';
import { ReactComponent as MenuBackIcon } from '@/assets/img/menu-back-icon.svg';

import { ReactComponent as VaccinationIconGrey } from '@/assets/img/menu-vacc-icon.svg';
import { ReactComponent as VaccinationIconGreySelected } from '@/assets/img/menu-vacc-icon-selected.svg';

import { ReactComponent as InsuranceIconGrey } from '@/assets/img/menu-doc-icon.svg';
import { ReactComponent as InsuranceIconGreySelected } from '@/assets/img/menu-doc-icon-selected.svg';
import BackIcon from '@/assets/img/back-arrow.svg';

import './MyPetProfile.scss';
import { useGetCustomersDetails } from '../api/getCustomerList';
import { Loader } from '@/components/Loader/Loader';
import { FormField } from '@/features/intakeform/types';
import { PetImages } from './MyPetImages';

export default function PetDetails() {
  const { id, phone } = useParams();
  const getPetMutation = useGetPet();
  const navigate = useNavigate();
  const useGetCustomerMutation = useGetCustomersDetails();
  const [customerDetail, setCustomerDetail] = useState<Customers>();

  const tabs = [
    {
      label: 'Profile',
      icon: PawIconGrey,
      selectedIcon: PawIconSelected,
      key: 'profile',
    },
    {
      label: 'Vaccination',
      icon: VaccinationIconGrey,
      selectedIcon: VaccinationIconGreySelected,
      key: 'vaccination',
    },
    {
      label: 'Documents',
      icon: InsuranceIconGrey,
      selectedIcon: InsuranceIconGreySelected,
      key: 'document',
    },
    {
      label: 'Images',
      icon: PawIconGrey,
      selectedIcon: PawIconSelected,
      key: 'images',
    },
  ];
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [petDetail, setPetDetail] = useState<Pets>();
  const [customFormFields, setCustomFormFields] = useState<FormField[]>([]);

  useEffect(() => {
    getCustomerDetails();
  }, []);

  const getCustomerDetails = async () => {
    const res = await useGetCustomerMutation.mutateAsync({
      phone: phone,
    });
    setCustomerDetail(res);
    getPetDetail(res.id);
  };

  const getPetDetail = async (customerId: string) => {
    const res = await getPetMutation.mutateAsync({
      petId: id ? id : '',
      parentId: customerId ? customerId : '',
    });
    if (res) {
      const customFields = res.fields;
      if (customFields) {
        customFields.forEach((field: FormField) => {
          if (res[field.fieldName as keyof typeof res]) {
            field.fieldValue = res[field.fieldName as keyof typeof res];
          }
        });
        setCustomFormFields([...customFields]);
      }
      setPetDetail(res);
    }
  };
  const onTabChange = (index: number) => {
    setSelectedTabIndex(index);
  };
  const onPetAdded = () => {
    customerDetail && getPetDetail(customerDetail?.id);
  };
  return (
    <section
      className={`container-bg my-pet-detail ${
        useGetCustomerMutation.isLoading || getPetMutation.isLoading ? 'loading' : ''
      }`}
    >
      {useGetCustomerMutation.isLoading || getPetMutation.isLoading ? (
        <div>
          {' '}
          <Loader text="" />
        </div>
      ) : (
        customerDetail &&
        petDetail && (
          <>
            <div
              className="back-nav"
              onClick={() => navigate(`/customer-details/${phone}/?selected-tab=pets`)}
            >
              <MenuBackIcon /> <span>Back</span>
            </div>
            <div className="pet-detail-top-section">
              <div className="my-pet">
                {petDetail && <PetDetailCard data={petDetail} onChange={() => {}} />}
              </div>
            </div>
            <div className="bottom-pet-details">
              <div className="left-nav">
                <VerticalTabs
                  tabs={tabs}
                  selectedTabIndex={selectedTabIndex}
                  onChange={onTabChange}
                />
              </div>
              <div className="tab-container">
                {petDetail && id && (
                  <>
                    {selectedTabIndex == 0 && (
                      <PetProfileForm
                        onSuccess={onPetAdded}
                        parent={customerDetail}
                        pet={petDetail}
                        isEditMode={false}
                        customFormFields={customFormFields}
                      />
                    )}
                    {selectedTabIndex == 1 && (
                      <PetVaccinationForm
                        petVaccination={
                          petDetail.petVaccination
                            ? petDetail.petVaccination
                            : {
                                id: '',
                                rabies: false,
                                rabiesExpiry: '',
                                rabiesTaken: '',
                                dhlpp: false,
                                dhlppExpiry: '',
                                dhlppTaken: '',
                                bordetella: false,
                                bordetellaExpiry: '',
                                bordetellaTaken: '',
                                canine: false,
                                canineExpiry: '',
                                canineTaken: '',
                              }
                        }
                      />
                    )}
                    {selectedTabIndex == 2 && (
                      <PetInsuranceForm insurance={petDetail.petInsurance} />
                    )}
                      {selectedTabIndex == 3 && (<PetImages petImages={petDetail?.petImages} />)}
                  </>
                )}
              </div>
            </div>
          </>
        )
      )}
    </section>
  );
}
